module.exports = function sign(number) {
	return number >= 0 ? 1 : -1;
};



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/helpers/sign.js
// module id = ./node_modules/es-abstract/helpers/sign.js
// module chunks = 0 1